export const AGILETICS_WEB_ESCROW_CONTAINER_TAG_NAME = 'agiletics-web-escrow-container';
